import loadable from '@loadable/component';

export const CmsSplitContentBlockLoadable = loadable(
  () => import('./CmsSplitContentBlock'),
  { resolveComponent: (module) => module.CmsSplitContentBlock },
);
